<template>
  <div>
    <!-- 商品手续费比例配置 -->
    <baseBreadcrumb :page="$t('message.commodityCommissionRatioConfiguration')"
      :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 商品来源 -->
          <el-table-column align="center" :label="$t('message.commoditySource')" prop="type_name">
          </el-table-column>
          <!-- LOGO -->
          <el-table-column align="center" label="LOGO">
            <template slot-scope="scope">
              <img :src="scope.row.logo" alt="" style="width: 80px;height: 80px;">
            </template>
          </el-table-column>
          <!-- 当前生效手续费比例 -->
          <el-table-column align="center" :label="$t('message.currentActiveCommissionRate')">
            <template slot-scope="scope">
              {{ scope.row.rate * 100 }} %
            </template>
          </el-table-column>
          <!-- 生效规则 -->
          <el-table-column align="center" :label="$t('message.effectiveRule')" prop="rule_type_name">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="edit(scope.row)" v-if="isAuth(434)">{{ $t('message.edit')
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 手续费比例调整 -->
    <el-dialog :title="$t('message.commissionRateAdjustment')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="500px" center>

      <div class="content">
        <!-- 商品来源 -->
        <div class="row">
          <div class="label">{{ $t('message.commoditySource') }}:</div>
          <div class="val">{{ editData.type }}</div>
        </div>
        <!-- 生效手续费比例 -->
        <div class="row">
          <div class="label">{{ $t('message.effectiveCommissionRate') }}:</div>
          <div class="val">
            <el-input v-model="editData.rateNum" type="number"></el-input> %
          </div>
        </div>
        <!-- 商品来源 -->
        <div class="row" style="margin-top: 50px;">
          <div class="val" v-for="(item, index) in typeList" :key="index">
            <el-radio v-model="editData.rule_type" :label="item.key">{{ item.value }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {
        pageSize: 10,
        page: 1,
      },
      total: 0,
      tableData: [],
      typeList: [],
      dialogVisible: false,
      editData: {}
    };
  },
  created() {
    this.serviceRateList()
    this.$api.siteConfiguration.ruleTypes().then(res => {
      this.typeList = res.data
    })
  },
  methods: {
    serviceRateList() {
      this.$api.siteConfiguration.serviceRateList().then(res => {
        this.tableData = res.data
        this.total = res.data.length - 0
        console.log(res);
      })
    },
    // 修改
    edit(item) {
      item.rateNum = item.rate * 100
      this.editData = JSON.parse(JSON.stringify(item))
      this.dialogVisible = true

    },
    // 保存
    save() {
      let datas = {
        type: this.editData.type,
        rule_type: this.editData.rule_type,
        rate: this.editData.rateNum / 100,
        logo: this.editData.logo ? this.editData.logo : '-',
      }
      this.$confirm(
        " 保存后，客户下单将根据最新的配置生效",
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.cancel"),
          cancelButtonText: this.$t("message.ok"),
          cancelButtonClass: 'primary',
          confirmButtonClass: 'dark',
          type: "warning",
          type: "warning",
          center: true,
        }
      )
        .then(() => {

        })
        .catch(() => {
          this.$api.siteConfiguration.setRule(datas).then(res => {
            this.$message.success(res.msg)
            this.serviceRateList()
            this.dialogVisible = false
          })
        });


    },
    // 分页
    handleCurrentChange(val) {
      this.data.page = val;
      this.serviceRateList()
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.serviceRateList()
    },
  }
}
</script>
<style lang='scss' scoped>
/deep/.el-radio__inner {
  transform: scale(1.5) !important;
}

.content {
  padding: 0 15px;

  .row {
    display: flex;
    margin-bottom: 20px;
    line-height: 40px;

    .label {
      width: 150px;
      margin-right: 20px;
    }

    .val {
      flex: 1;
      display: flex;

      /deep/.el-input {
        width: 100px;
      }
    }
  }
}
</style>